import { Page } from '@Components/Page/Page';
import { CategoryPathing } from './CategoryPathing';

const PAGE_TYPE = 'Category Pathing Demo';

// Hidden, internal-only comparison route (see the `commerce/amc-experiment` location entry).
// Renders the Category Pathing dashboard against the static CDN-CSV demo dataset so it can be
// compared against the live version at /amc-insights/category-pathing. Standalone route, so it
// owns its own <Page> chrome (the live version renders inside the AMC Insights shell instead).
export const CategoryPathingDemo = () => (
  <Page title='Category Pathing (Demo)' pageType={PAGE_TYPE}>
    <CategoryPathing demo />
  </Page>
);
